export const WINDOW_ACTIVE = 'WINDOW_ACTIVE'
export const CHANGE_STAND_ALONE_MODE = 'CHANGE_STAND_ALONE_MODE'

export const CHANGE_WINDOW_RESIZABLE = 'CHANGE_WINDOW_RESIZABLE'
